export const getResourceIcon = (resource: string): string => {
  const resourceLower = resource.toLowerCase();

  if (resourceLower.includes('fitbit')) {
    return '🟣'; // Purple circle for Fitbit
  } else if (resourceLower.includes('garmin')) {
    return '🔵'; // Blue circle for Garmin
  } else if (resourceLower.includes('apple')) {
    return '⚪'; // White circle for Apple Watch
  } else if (resourceLower.includes('oura')) {
    return '⚫'; // Black circle for Oura Ring
  } else if (resourceLower.includes('whoop')) {
    return '🟡'; // Yellow circle for WHOOP
  } else if (resourceLower.includes('polar')) {
    return '🔴'; // Red circle for Polar
  } else if (resourceLower.includes('suunto')) {
    return '🟠'; // Orange circle for Suunto
  } else if (resourceLower.includes('samsung')) {
    return '🟢'; // Green circle for Samsung
  }

  return '🔘'; // Default gray circle
};

const RESOURCE_DISPLAY_NAMES: { [key: string]: string } = {
  FITBIT: 'Fitbit',
  GARMIN: 'Garmin',
  APPLE_HEALTH: 'Apple Health',
  APPLE_WATCH: 'Apple Watch',
  OURA: 'Oura Ring',
  WHOOP: 'WHOOP',
  POLAR: 'Polar',
  SUUNTO: 'Suunto',
  SAMSUNG: 'Samsung Health',
  STRAVA: 'Strava',
  GOOGLE_FIT: 'Google Fit',
};

export const getResourceDisplayName = (resource: string): string => {
  return RESOURCE_DISPLAY_NAMES[resource.toUpperCase()] || resource;
};
